/**
 * precart.js — Dual-panier mode hybride (Epic 24, Stories 24.5-24.8 + F1-F7)
 *
 * Loaded only when store_mode === 'hybrid'.
 * Reads window.__abPrecartConfig set by theme.liquid.
 */

(function () {
  'use strict';

  var CFG = window.__abPrecartConfig;
  if (!CFG || !CFG.storeHandle) return;

  var EF_BASE = CFG.efBase;
  var STORE_HANDLE = CFG.storeHandle;
  var STORE_NAME = CFG.storeName;
  var COOKIE_NAME = 'ab_precart_sid';
  var COOKIE_MAX_AGE = 30 * 24 * 3600;

  // ============================================================
  // Cookie session (Story 24.7)
  // ============================================================

  function getSessionId() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (match) return decodeURIComponent(match[1]);
    var id = crypto.randomUUID();
    document.cookie = COOKIE_NAME + '=' + id + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
    return id;
  }

  var sessionId = getSessionId();

  // ============================================================
  // Public API — fire-and-forget (Story 24.4)
  // ============================================================

  function efCall(action, data) {
    return fetch(EF_BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: action,
        data: Object.assign({ session_id: sessionId, store_handle: STORE_HANDLE }, data || {}),
      }),
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  window.__abPrecart = {
    register: function (variantId, quantity) {
      efCall('register', { variant_id: String(variantId), quantity: quantity || 1 });
    },
    updateQty: function (variantId, quantity) {
      efCall('update-qty', { variant_id: String(variantId), quantity: quantity });
    },
    remove: function (variantId) {
      efCall('remove', { variant_id: String(variantId) });
    },
  };

  // ============================================================
  // Merge on login (Story 24.7)
  // ============================================================

  if (CFG.customerId && sessionId !== String(CFG.customerId)) {
    efCall('merge', { anonymous_session_id: sessionId, customer_id: String(CFG.customerId) });
  }

  // ============================================================
  // Page /cart logic
  // ============================================================

  var isCartPage = /^\/cart\/?/.test(window.location.pathname);

  if (!isCartPage) {
    checkPostCheckoutBanner();
    return;
  }

  // Auto-restore after checkout
  var lastCheckout = localStorage.getItem('ab_precart_checkout');
  if (lastCheckout) {
    localStorage.removeItem('ab_precart_checkout');
    efCall('list', {}).then(function (data) {
      if (!data) return doSync();
      efCall('clear-universe', { universe: lastCheckout });
      var otherUniverse = lastCheckout === 'extension' ? 'magasin' : 'extension';
      var remaining = data[otherUniverse] || [];
      if (!remaining.length) return doSync();
      var addItems = remaining.map(function (i) { return { id: parseInt(i.variant_id), quantity: i.quantity }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addItems }),
      }).then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { store_handle: STORE_HANDLE, store_name: STORE_NAME } }),
        });
      }).then(function () {
        window.location.reload();
      });
    });
    return;
  }

  doSync();

  // ============================================================
  // Bidirectional sync cart <-> registre
  // ============================================================

  function doSync() {
    Promise.all([
      fetch('/cart.js').then(function (r) { return r.json(); }),
      efCall('list', {}),
    ]).then(function (results) {
      var shopifyCart = results[0];
      var registre = results[1] || { extension: [], magasin: [] };

      var cartIds = {};
      (shopifyCart.items || []).forEach(function (item) {
        cartIds[String(item.variant_id)] = item;
      });

      var knownIds = {};
      var allRegistreItems = (registre.extension || []).concat(registre.magasin || []);
      allRegistreItems.forEach(function (i) { knownIds[String(i.variant_id)] = true; });

      var ops = [];

      (shopifyCart.items || []).forEach(function (item) {
        if (!knownIds[String(item.variant_id)]) {
          ops.push(efCall('register', { variant_id: String(item.variant_id), quantity: item.quantity }));
        }
      });

      allRegistreItems.forEach(function (item) {
        if (!cartIds[String(item.variant_id)]) {
          ops.push(efCall('remove', { variant_id: String(item.variant_id) }));
        }
      });

      if (ops.length) {
        return Promise.all(ops).then(function () {
          return efCall('list', {});
        });
      }
      return registre;
    }).then(function (data) {
      if (!data || (!data.extension.length && !data.magasin.length)) return;
      splitCartDOM(data);
    });
  }

  // ============================================================
  // DOM split (Story 24.5 + F1-F7)
  // ============================================================

  function splitCartDOM(data) {
    var extSet = {};
    var magSet = {};
    data.extension.forEach(function (i) { extSet[String(i.variant_id)] = i; });
    data.magasin.forEach(function (i) { magSet[String(i.variant_id)] = i; });

    var cartItems = document.querySelectorAll('#main-cart-items .cart-item[data-variant-id]');
    if (!cartItems.length) return;

    var wrapper = document.querySelector('#main-cart-items .js-contents');
    if (!wrapper) return;

    var extContainer = document.createElement('div');
    extContainer.className = 'precart-section precart-extension';
    var magContainer = document.createElement('div');
    magContainer.className = 'precart-section precart-magasin';

    var extCount = 0, magCount = 0;
    cartItems.forEach(function (el) {
      if (magSet[el.getAttribute('data-variant-id')]) magCount++;
      else extCount++;
    });

    if (extCount) {
      extContainer.innerHTML =
        '<div class="precart-header">' +
        '<h3 class="precart-title">L\'Extension</h3>' +
        '<p class="precart-subtitle">Livré à domicile par Aventure Bio</p>' +
        '</div>';
    }
    if (magCount) {
      magContainer.innerHTML =
        '<div class="precart-header">' +
        '<h3 class="precart-title">Mon Magasin</h3>' +
        '<p class="precart-subtitle">À retirer en magasin</p>' +
        '</div>';
    }

    var extTotal = 0, magTotal = 0;
    cartItems.forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      if (magSet[vid]) {
        magContainer.appendChild(el);
        magTotal += parseFloat(el.getAttribute('data-line-total') || '0');
      } else {
        extContainer.appendChild(el);
        extTotal += parseFloat(el.getAttribute('data-line-total') || '0');
      }
    });

    var termsHtml = CFG.termsLabel
      ? '<div class="precart-terms"><label><input type="checkbox" class="precart-terms-checkbox" /> ' + CFG.termsLabel + '</label></div>'
      : '';

    if (extCount) {
      extContainer.insertAdjacentHTML('beforeend',
        '<div class="precart-footer">' +
        '<div class="precart-subtotal">Sous-total : ' + formatMoney(extTotal) + '</div>' +
        termsHtml +
        '<div class="precart-terms-error hide">Veuillez accepter les CGV pour commander.</div>' +
        '<button class="precart-checkout-btn ext-btn" data-universe="extension">' +
        'Commander mes produits Extension</button></div>'
      );
    }
    if (magCount) {
      magContainer.insertAdjacentHTML('beforeend',
        '<div class="precart-footer">' +
        '<div class="precart-subtotal">Sous-total : ' + formatMoney(magTotal) + '</div>' +
        termsHtml +
        '<div class="precart-terms-error hide">Veuillez accepter les CGV pour commander.</div>' +
        '<button class="precart-checkout-btn ext-btn" data-universe="magasin">' +
        'Commander mes produits Magasin</button></div>'
      );
    }

    // Remove non-item children (e.g. previous precart sections) without destroying items
    while (wrapper.firstChild) {
      wrapper.removeChild(wrapper.firstChild);
    }
    if (extCount) wrapper.appendChild(extContainer);
    if (magCount) wrapper.appendChild(magContainer);

    // F5 — Hide original checkout/CGV block (keep login link visible)
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      var ctaBlock = cartFooter.querySelector('.cart__ctas');
      if (ctaBlock) ctaBlock.style.display = 'none';
      var origTerms = cartFooter.querySelector('.cart__terms');
      if (origTerms) origTerms.style.display = 'none';
    }

    // Bind checkout buttons
    document.querySelectorAll('.precart-checkout-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // F4 — Force login
        if (!CFG.customerId) {
          window.location = '/account/login?checkout_url=/cart';
          return;
        }

        // F7 — Check local CGV checkbox
        var footer = btn.closest('.precart-footer');
        var localTerms = footer ? footer.querySelector('.precart-terms-checkbox') : null;
        var localError = footer ? footer.querySelector('.precart-terms-error') : null;
        if (localTerms && !localTerms.checked) {
          if (localError) localError.classList.remove('hide');
          return;
        }
        if (localError) localError.classList.add('hide');

        var universe = btn.getAttribute('data-universe');
        var section = btn.closest('.precart-section');
        var domItems = [];
        section.querySelectorAll('.cart-item[data-variant-id]').forEach(function (el) {
          var qty = el.querySelector('input[type="number"], .quantity__input');
          domItems.push({
            variant_id: el.getAttribute('data-variant-id'),
            quantity: qty ? parseInt(qty.value) || 1 : 1,
          });
        });
        checkoutUniverse(universe, domItems, btn);
      });
    });
  }

  // ============================================================
  // Checkout sequence (Story 24.6 + F6)
  // ============================================================

  function checkoutUniverse(universe, items, clickedBtn) {
    // F6 — Only spinner on clicked button, other just disabled
    var btns = document.querySelectorAll('.precart-checkout-btn');
    btns.forEach(function (b) {
      b.disabled = true;
      if (b === clickedBtn) b.textContent = 'Préparation...';
    });

    var addItems = items.map(function (i) { return { id: parseInt(i.variant_id), quantity: i.quantity }; });

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addItems }),
        });
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              store_handle: STORE_HANDLE,
              store_name: STORE_NAME,
              precart_universe: universe,
            },
          }),
        });
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var expected = items.reduce(function (s, i) { return s + i.quantity; }, 0);
        if (cart.item_count !== expected) throw new Error('Cart verification failed');
        localStorage.setItem('ab_precart_checkout', universe);
        window.location = '/checkout';
      })
      .catch(function (err) {
        console.error('Precart checkout error:', err);
        restoreFullCart();
        btns.forEach(function (b) {
          b.disabled = false;
          b.textContent = b.getAttribute('data-universe') === 'extension'
            ? 'Commander mes produits Extension'
            : 'Commander mes produits Magasin';
        });
        alert('Erreur lors de la mise en panier. Veuillez réessayer.');
      });
  }

  function restoreFullCart() {
    efCall('list', {}).then(function (data) {
      if (!data) return;
      var all = (data.extension || []).concat(data.magasin || []);
      if (!all.length) return;
      var addItems = all.map(function (i) { return { id: parseInt(i.variant_id), quantity: i.quantity }; });
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: addItems }),
          });
        })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { store_handle: STORE_HANDLE, store_name: STORE_NAME } }),
          });
        })
        .then(function () { window.location.reload(); });
    });
  }

  // ============================================================
  // Post-checkout banner (Story 24.8 — non-cart pages only)
  // ============================================================

  function checkPostCheckoutBanner() {
    var lastCheckout = localStorage.getItem('ab_precart_checkout');
    if (!lastCheckout) return;

    efCall('list', {}).then(function (data) {
      if (!data) return;
      localStorage.removeItem('ab_precart_checkout');
      efCall('clear-universe', { universe: lastCheckout });

      var otherUniverse = lastCheckout === 'extension' ? 'magasin' : 'extension';
      var remaining = data[otherUniverse] || [];
      if (!remaining.length) return;

      var label = otherUniverse === 'extension' ? 'Extension' : 'Mon Magasin';
      var banner = document.createElement('div');
      banner.className = 'precart-banner';
      banner.innerHTML =
        '<div class="precart-banner__content">' +
        '<span>Vous avez encore ' + remaining.length + ' article(s) dans votre panier ' + label + '.</span>' +
        '<a href="/cart" class="precart-banner__link">Voir mon panier</a>' +
        '<button class="precart-banner__close" aria-label="Fermer">&times;</button>' +
        '</div>';

      banner.querySelector('.precart-banner__close').addEventListener('click', function () {
        banner.remove();
      });

      var addItems = remaining.map(function (i) { return { id: parseInt(i.variant_id), quantity: i.quantity }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addItems }),
      }).then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { store_handle: STORE_HANDLE, store_name: STORE_NAME } }),
        });
      });

      document.body.insertBefore(banner, document.body.firstChild);
    });
  }

  // ============================================================
  // Helpers
  // ============================================================

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }
})();
